<template>
  <div id="ag-grid-demo">
    <busca-produtividade />

    <paginacao-placeholder v-if="loading" />
    <div v-else>
      <div v-for="(item,index) in data" :key="index" class="mb-5">
        <vs-table stripe :data="item.data">
          <template slot="header">
            <h4 class="mb-5">{{ item.titulo }}</h4>
          </template>
          <template slot="thead">
            <vs-th>Titulo</vs-th>
            <vs-th width="200">Quantidade</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{tr.titulo}}</vs-td>

              <vs-td>{{tr.quantidade}}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import PaginacaoPlaceholder from "@/components/placeholders/PaginacaoPlaceholder";
import api from "@/services/api-service";
import BuscaProdutividade from "./components/BuscaProdutividade";

export default {
  components: { PaginacaoPlaceholder, BuscaProdutividade },
  data() {
    return {
      loading: true,
      data: []
    };
  },
  async mounted() {
    await this.buscar();
  },
  watch: {
    $route(to) {
      this.buscar(to);
    }
  },
  methods: {
    async buscar(to) {
      this.loading = true;
      let route = to || this.$route;

      let { data } = await api().get("/relatorios/produtividade", {
        params: route.query
      });

      this.data = data;
      this.loading = false;
    }
  }
};
</script>